var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 280,
    viewBox: "0 0 400 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2975_77233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.914 240.22C434.476 149.215 363.332 2.6736 205.776 0.0290439C118.204 -1.43242 -0.577986 56.1679 0.00211665 189.718C0.280566 250.868 78.8729 306.264 163.057 233.841C224.595 180.903 338.643 321.714 383.914 240.22Z",
    fill: "#E7EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.985 276.574C147.008 276.574 181.886 273.263 181.886 269.178C181.886 265.093 147.008 261.781 103.985 261.781C60.9614 261.781 26.084 265.093 26.084 269.178C26.084 273.263 60.9614 276.574 103.985 276.574Z",
    fill: "#D7DDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.961 280.563C292.346 280.563 351.025 274.96 351.025 268.049C351.025 261.138 292.346 255.535 219.961 255.535C147.576 255.535 88.8965 261.138 88.8965 268.049C88.8965 274.96 147.576 280.563 219.961 280.563Z",
    fill: "#D7DDF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1048 240H31.8438V264.178H41.1048V240Z",
    fill: "#0D318B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.481 241.242V262.582H36.5518C35.5155 256.116 35.5562 248.997 36.5546 241.242H123.481Z",
    fill: "white",
    stroke: "#04102E",
    strokeWidth: 0.207183
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1435 242.299H123.605V237.699H34.1435C32.8797 237.699 31.8438 238.735 31.8438 239.999C31.8438 241.263 32.8797 242.299 34.1435 242.299Z",
    fill: "#0D318B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3092 266.641H123.605V261.689H34.3092C32.9418 261.689 31.8438 262.788 31.8438 264.155C31.8438 265.522 32.9418 266.62 34.3092 266.62V266.641Z",
    fill: "#0D318B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.167 237.699H204.199C207.887 237.699 210.891 238.611 210.891 242.299C204.717 247.976 203.681 257.092 210.891 261.712C210.891 265.4 207.908 266.663 204.199 266.663H101.167V237.699Z",
    fill: "#103EB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.255 261.608C100.176 255.047 100.015 248.612 101.252 242.402H210.684C208.599 245.779 207.608 249.07 207.636 252.278C207.664 255.479 208.708 258.589 210.678 261.608H101.255Z",
    fill: "#BDC7ED",
    stroke: "#04102E",
    strokeWidth: 0.207183
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4179 247.541H41.1055",
    stroke: "#04102E",
    strokeWidth: 0.331494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4179 256.367H41.1055",
    stroke: "#04102E",
    strokeWidth: 0.331494,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.108 177.645L276.549 183.985L281.003 122.535C286.639 121.457 292.771 121.436 299.422 122.535C304.353 124.337 306.363 129.434 306.798 142.528C307.253 155.725 306.59 168.094 307.108 177.666V177.645Z",
    fill: "#BDC7ED"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.853 94.5645H219.802V134.696H251.853V94.5645Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.817 72.8711L209.194 101.525H261.86L235.817 72.8711Z",
    fill: "#5B86EF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.009 67.2942C183.413 65.5319 182.311 63.7761 180.549 63.3725C178.787 62.9689 177.031 64.0703 176.627 65.8326C176.224 67.5948 177.325 69.3506 179.087 69.7542C180.85 70.1579 182.605 69.0565 183.009 67.2942Z",
    stroke: "#081E54",
    strokeWidth: 0.74586,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2836 157.429C54.0647 155.799 53.3763 153.844 51.7459 153.063C50.1154 152.282 48.1604 152.97 47.3793 154.601C46.5981 156.231 47.2866 158.186 48.917 158.967C50.5474 159.748 52.5024 159.06 53.2836 157.429Z",
    stroke: "#081E54",
    strokeWidth: 0.74586,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.004 267.058H165.975V137.838C165.975 131.623 168.585 120.518 187.128 120.518H234.283C240.291 120.766 241.99 121.388 245.906 122.962C240.54 122.424 234.905 125.179 234.283 135.02V166.802V245.801C234.283 257.569 239.641 267.1 202.004 267.1V267.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.67 266.898H199.18L219.68 137.681C219.68 131.466 222.288 120.361 240.811 120.361H287.915C293.916 120.61 295.613 121.231 299.525 122.806C294.165 122.267 288.535 125.023 287.915 134.864V166.645V245.641C287.915 257.409 283.527 268.596 255.67 266.939V266.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.722 121.134C117.722 121.673 117.867 122.212 118.095 122.75C119.048 124.843 121.514 125.775 123.606 124.822C125.181 124.118 126.092 122.543 126.051 120.927C126.051 120.388 125.906 119.85 125.678 119.311C124.725 117.218 122.259 116.286 120.167 117.239C118.592 117.944 117.681 119.518 117.722 121.134ZM124.497 119.829C125.139 121.238 124.497 122.895 123.109 123.538C121.7 124.18 120.043 123.538 119.4 122.149C118.758 120.741 119.4 119.083 120.788 118.441C122.197 117.799 123.855 118.441 124.497 119.829Z",
    fill: "#081E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.771 130.146C127.771 130.685 127.916 131.223 128.144 131.762C129.097 133.855 131.562 134.787 133.655 133.834C135.229 133.129 136.141 131.555 136.1 129.939C136.1 129.4 135.955 128.861 135.727 128.323C134.774 126.23 132.308 125.298 130.216 126.251C128.641 126.955 127.729 128.53 127.771 130.146ZM134.546 128.841C135.188 130.25 134.546 131.907 133.158 132.549C131.749 133.192 130.091 132.549 129.449 131.161C128.807 129.752 129.449 128.095 130.837 127.453C132.246 126.81 133.904 127.453 134.546 128.841Z",
    fill: "#081E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.763 119.603L121.306 133.319C120.995 133.692 120.415 133.754 120.042 133.443C119.669 133.133 119.607 132.552 119.918 132.179L131.375 118.464C131.686 118.091 132.266 118.029 132.639 118.34C133.012 118.65 133.074 119.23 132.763 119.603Z",
    fill: "#081E54"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M261.652 194.551H222.473C221.741 194.551 221.147 195.144 221.147 195.877V196.105C221.147 196.837 221.741 197.431 222.473 197.431H261.652C262.384 197.431 262.978 196.837 262.978 196.105V195.877C262.978 195.144 262.384 194.551 261.652 194.551Z",
    fill: "#344266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.03 163.662H236.851C236.119 163.662 235.525 164.256 235.525 164.988V165.216C235.525 165.948 236.119 166.542 236.851 166.542H276.03C276.762 166.542 277.356 165.948 277.356 165.216V164.988C277.356 164.256 276.762 163.662 276.03 163.662Z",
    fill: "#E6EBEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.001 157.528H236.976C236.188 157.528 235.525 156.885 235.525 156.077C235.525 155.29 236.168 154.627 236.976 154.627H255.001C255.788 154.627 256.451 155.269 256.451 156.077C256.451 156.865 255.809 157.528 255.001 157.528Z",
    fill: "#E6EBEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M203.164 194.551H187.521C186.789 194.551 186.195 195.144 186.195 195.877V196.105C186.195 196.837 186.789 197.431 187.521 197.431H203.164C203.896 197.431 204.49 196.837 204.49 196.105V195.877C204.49 195.144 203.896 194.551 203.164 194.551Z",
    fill: "#344266"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M261.652 209.197H222.473C221.741 209.197 221.147 209.791 221.147 210.523V210.751C221.147 211.483 221.741 212.077 222.473 212.077H261.652C262.384 212.077 262.978 211.483 262.978 210.751V210.523C262.978 209.791 262.384 209.197 261.652 209.197Z",
    fill: "#344266"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M203.164 209.197H187.521C186.789 209.197 186.195 209.791 186.195 210.523V210.751C186.195 211.483 186.789 212.077 187.521 212.077H203.164C203.896 212.077 204.49 211.483 204.49 210.751V210.523C204.49 209.791 203.896 209.197 203.164 209.197Z",
    fill: "#344266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.872 187.756H177.121V234.165H270.872V187.756Z",
    stroke: "#C8CFE6",
    strokeWidth: 0.662987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.121 203.215H270.872",
    stroke: "#C8CFE6",
    strokeWidth: 0.662987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M261.652 225.027H222.473C221.741 225.027 221.147 225.621 221.147 226.353V226.581C221.147 227.314 221.741 227.907 222.473 227.907H261.652C262.384 227.907 262.978 227.314 262.978 226.581V226.353C262.978 225.621 262.384 225.027 261.652 225.027Z",
    fill: "#344266"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M203.164 225.027H187.521C186.789 225.027 186.195 225.621 186.195 226.353V226.581C186.195 227.314 186.789 227.907 187.521 227.907H203.164C203.896 227.907 204.49 227.314 204.49 226.581V226.353C204.49 225.621 203.896 225.027 203.164 225.027Z",
    fill: "#344266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.121 219.045H270.872",
    stroke: "#C8CFE6",
    strokeWidth: 0.662987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.875 187.756V233.378",
    stroke: "#C8CFE6",
    strokeWidth: 0.662987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.962 202.582C295.962 200.323 294.056 198.5 291.756 198.5L243.337 198.562C241.037 198.562 239.173 200.406 239.194 202.664L239.711 268.59C239.711 270.848 241.618 272.672 243.917 272.672L292.336 272.61C294.636 272.61 296.5 270.766 296.48 268.507L295.962 202.582Z",
    fill: "#344266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.482 272.586L240.064 272.648C237.764 272.648 235.879 270.825 235.858 268.567L235.34 202.641C235.34 200.383 237.184 198.539 239.484 198.539L287.902 198.477C290.202 198.477 292.087 200.3 292.108 202.558L292.626 268.484C292.626 270.742 290.782 272.586 288.482 272.586Z",
    fill: "#0D318B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.557 222.488L244.414 222.529C242.923 222.529 241.7 221.348 241.7 219.898L241.597 207.529C241.597 206.079 242.778 204.877 244.269 204.877L282.412 204.836C283.904 204.836 285.126 206.017 285.126 207.467L285.23 219.836C285.23 221.286 284.049 222.488 282.557 222.488Z",
    fill: "#F6F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.557 222.488L244.414 222.529C242.923 222.529 241.7 221.348 241.7 219.898L241.597 207.529C241.597 206.079 242.778 204.877 244.269 204.877L282.412 204.836C283.904 204.836 285.126 206.017 285.126 207.467L285.23 219.836C285.23 221.286 284.049 222.488 282.557 222.488Z",
    stroke: "white",
    strokeWidth: 0.766579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.242 237.784H245.409C243.689 237.784 242.28 236.395 242.26 234.676C242.26 232.935 243.648 231.527 245.388 231.506H249.221C250.941 231.506 252.35 232.894 252.37 234.614C252.37 236.354 250.982 237.763 249.242 237.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.485 237.784H261.652C259.933 237.784 258.524 236.395 258.503 234.676C258.503 232.935 259.891 231.527 261.631 231.506H265.464C267.184 231.506 268.593 232.894 268.613 234.614C268.613 236.354 267.225 237.763 265.485 237.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.874 237.756H278.041C276.321 237.756 274.912 236.368 274.892 234.648C274.892 232.908 276.28 231.499 278.02 231.479H281.853C283.573 231.479 284.981 232.867 285.002 234.586C285.002 236.327 283.614 237.735 281.874 237.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.345 249.528H245.512C243.793 249.528 242.384 248.14 242.363 246.42C242.363 244.68 243.751 243.271 245.492 243.25H249.325C251.044 243.25 252.453 244.638 252.474 246.358C252.474 248.098 251.086 249.507 249.345 249.528Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.589 249.506H261.756C260.036 249.506 258.627 248.118 258.606 246.398C258.606 244.658 259.995 243.249 261.735 243.229H265.568C267.287 243.229 268.696 244.617 268.717 246.336C268.717 248.077 267.329 249.485 265.589 249.506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.976 249.485H278.143C276.424 249.485 275.015 248.097 274.994 246.377C274.994 244.637 276.382 243.228 278.123 243.207H281.955C283.675 243.207 285.084 244.595 285.105 246.315C285.105 248.055 283.717 249.464 281.976 249.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.428 261.252H245.595C243.876 261.252 242.467 259.864 242.446 258.145C242.446 256.404 243.834 254.995 245.575 254.975H249.408C251.127 254.975 252.536 256.363 252.557 258.082C252.557 259.823 251.169 261.232 249.428 261.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.672 261.233H261.839C260.119 261.233 258.71 259.845 258.689 258.125C258.689 256.385 260.078 254.976 261.818 254.955H265.651C267.37 254.955 268.779 256.343 268.8 258.063C268.8 259.803 267.412 261.212 265.672 261.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.06 261.211H278.227C276.508 261.211 275.099 259.823 275.078 258.103C275.078 256.363 276.466 254.954 278.207 254.934H282.04C283.759 254.934 285.168 256.322 285.189 258.041C285.189 259.782 283.801 261.191 282.06 261.211Z",
    fill: "#FF8165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.368 219.588C244.767 219.588 244.27 219.112 244.27 218.511C244.27 217.931 244.746 217.434 245.347 217.434C245.948 217.434 246.445 217.91 246.445 218.511C246.445 219.091 245.968 219.588 245.368 219.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.563 266.457L279.221 266.416",
    stroke: "white",
    strokeWidth: 0.766579,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9692 237.462L103.592 237.669L104.007 230.853L86.3546 221.177L75.954 218.65L72.7219 216.992C67.7288 222.876 69.5727 237.172 76.9485 237.441L76.9692 237.462Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9264 234.537L116.892 236.837L122.279 229.067L114.447 224.323L90.9112 215.621L86.6017 220.345C81.6086 225.794 84.5506 233.646 91.9264 234.558V234.537Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.8791 231.077C96.8791 231.077 101.334 231.43 105.249 244.524C107.404 251.692 119.276 267.521 119.276 267.521L121.057 265.159L111.486 229.503C110.615 226.851 108.316 224.675 105.643 223.95L98.1429 221.92L96.8584 231.057L96.8791 231.077Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.684 264.124L123.108 266.9C123.585 267.563 126.651 269.241 126.651 269.241C126.817 269.987 126.092 270.236 125.512 270.215L115.774 268.185C115.774 268.185 113.619 267.294 116.665 263.357C118.26 264.476 119.897 265.367 120.684 264.103V264.124Z",
    fill: "#1F0F0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.301 231.08C107.301 231.08 118.427 241.253 123.026 254.347C125.554 261.515 131.583 267.544 131.583 267.544L133.24 265.183L121.845 229.526C120.851 226.874 118.447 224.699 115.712 223.974L108.109 221.943L107.301 231.08Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.659 263.67L135.705 265.908C136.326 266.467 139.724 267.524 139.724 267.524C140.076 268.228 139.413 268.601 138.854 268.704L128.909 268.622C128.909 268.622 126.609 268.166 128.578 263.732C130.401 264.499 132.224 265.058 132.659 263.67Z",
    fill: "#1F0F0C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.493 260.253L113.268 261.04C113.268 261.04 110.388 255.653 108.419 252.96C104.442 247.553 101.914 238.768 101.707 238.582C101.5 238.395 77.2384 238.602 76.016 238.437C72.8461 237.981 65.4082 233.236 71.9345 216.91L101.852 225.094C101.852 225.094 108.979 226.192 110.491 228.72C111.465 230.356 112.791 231.765 113.744 234.355C118.199 246.517 121.493 260.253 121.493 260.253Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.488 259.9L125.014 260.563C125.014 260.563 116.209 242.082 114.157 238.684C112.106 235.286 76.3672 233.049 76.3672 233.049L78.8534 216.826L99.7375 217.904C99.7375 217.904 111.402 221.426 112.459 221.757C113.515 222.089 120.373 220.763 124.475 228.864C128.577 236.964 133.508 259.92 133.508 259.92L133.488 259.9Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.26 205.534L97.9146 190.037C96.6922 186.287 93.025 184.65 90.2281 186.619C89.13 187.385 88.7571 189.125 89.4201 190.514L97.5624 207.751L103.281 205.534H103.26Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.8125 185.893L88.695 183.925L84.2613 183.262H82.0859L73.7157 185.893C70.8773 187.177 69.4891 190.389 70.4629 193.352L72.1825 202.903C69.7999 209.988 68.5568 211.729 68.7018 219.104C79.4547 221.342 97.9561 220.058 98.847 219.104C98.702 204.353 97.3346 193.455 93.8332 185.914L93.8125 185.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5919 183.947C88.5919 183.947 90.9952 190.473 86.5615 190.618C82.1278 190.763 79.9316 183.988 79.9316 183.988L83.2051 182.662L88.6126 183.967L88.5919 183.947Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7997 208.702L76.5331 194.365C78.2113 190.926 76.6574 187.569 73.2803 187.3C71.9544 187.197 70.5041 188.232 70.0276 189.6L64.1436 206.858L69.8204 208.681L69.7997 208.702Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1854 206.467C63.4395 209.43 64.5169 212.289 67.8318 213.532L84.883 216.204L84.075 212.703L71.7476 208.663L64.1854 206.467Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.105 203.543C103.115 205.76 103.716 208.743 101.872 211.375L97.4175 217.404L94.2891 215.705L98.122 208.205L101.105 203.543Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0752 212.7L86.8307 214.234C87.3901 214.544 87.8045 215.021 88.0117 215.622L88.9025 218.004C89.2133 218.833 88.5918 219.724 87.7009 219.703L84.3445 217.59C83.5986 217.134 83.0392 216.347 82.7492 215.415L82.252 213.861L84.0752 212.68V212.7Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9831 214.4L93.9375 215.145C93.3366 215.291 92.798 215.663 92.425 216.161L90.954 218.233C90.4361 218.958 90.809 219.973 91.6585 220.201L95.4499 219.041C96.2786 218.792 97.0452 218.191 97.5632 217.362L98.4334 215.995L96.9831 214.379V214.4Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.8223 220.72L106.264 221.548L106.327 219.622L82.8112 218.855C81.7546 218.814 80.8637 219.663 80.8223 220.72Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5022 221.135L117.598 221.922L125.388 205.948L101.831 205.182C101.499 205.182 101.189 205.368 101.044 205.658L93.4814 221.135H93.5022Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4551 221.155L118.551 221.943L125.988 206.694C126.154 206.342 125.906 205.948 125.533 205.928L102.597 205.182C102.39 205.182 102.204 205.285 102.1 205.472L94.4551 221.135V221.155Z",
    fill: "#0D318B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.517 213.633C109.206 214.627 109.952 215.476 111.195 215.518C112.438 215.559 113.723 214.772 114.033 213.778C114.344 212.783 113.598 211.934 112.355 211.892C111.112 211.851 109.828 212.638 109.517 213.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.204 243.199L113.226 229.069C113.226 229.069 110.243 223.434 101.044 223.434",
    stroke: "#3A6EEC",
    strokeWidth: 0.662987,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1709 191.801L73.7579 202.678L64.8076 199.114C66.6101 197.291 68.7027 188.299 73.6958 185.917C79.2069 183.286 78.1709 191.801 78.1709 191.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.813 185.896C93.813 185.896 97.2936 186.248 98.9511 192.339C100.609 198.43 102.183 199.715 102.183 199.715L95.4704 202.18L90.7881 189.501L93.7922 185.875L93.813 185.896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1694 201.225C97.1694 201.225 95.802 195.61 94.7868 193.435C93.7716 191.259 93.8337 190.141 93.8337 190.141",
    stroke: "#E6EBEF",
    strokeWidth: 0.559395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8145 199.65L78.5438 190.866L78.5852 189.664",
    stroke: "#E6EBEF",
    strokeWidth: 0.559395,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.7416 179.801C87.7416 179.801 87.3272 182.971 86.975 185.581C86.8921 186.286 86.4156 186.866 85.7733 187.135C85.1311 187.404 84.3852 187.28 83.8465 186.845C83.6601 186.7 83.4943 186.555 83.3286 186.431C82.5827 185.83 82.2512 184.835 82.4791 183.903C83.0592 181.5 84.1159 177.107 84.1159 177.107L87.7416 179.801Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6587 181.543L87.265 183.428L85.6904 181.543H87.6587Z",
    fill: "#5C2E24"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.5629 175.989C82.3972 175.057 83.0187 174.187 83.9303 174.042C84.9041 173.876 86.1265 173.669 87.1002 173.483C88.0118 173.317 88.737 173.98 89.0271 174.871C89.3793 175.927 89.5864 178.186 89.545 179.843C89.5243 180.775 88.9442 181.728 88.0326 181.894C87.0588 182.06 83.9718 181.625 83.3917 179.926C82.9566 178.621 82.7494 177.357 82.5215 176.01L82.5629 175.989Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3096 179.864C79.3096 179.864 79.3096 174.912 80.6977 173.565C83.1217 171.224 85.8151 170.913 88.5914 173.192C88.5914 173.192 88.177 177.377 83.5983 180.858L79.3096 179.864Z",
    fill: "#854335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7361 176.113C88.7361 176.155 89.3369 176.901 90.2693 177.895C90.7251 178.392 89.7099 179.511 89.109 179.283C88.5082 179.055 87.7002 177.087 87.7002 177.087L88.7361 176.113Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2823 178.558C84.2823 178.558 83.7436 184.608 85.9191 185.83C85.9191 185.83 78.2118 185.892 77.8804 183.696C77.1966 179.097 80.3458 174 80.3458 174H86.6649L84.2616 178.579L84.2823 178.558Z",
    fill: "#854335"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9859 178.887C85.3588 179.55 86.1047 179.84 86.6641 179.529C87.2235 179.219 87.3478 178.411 86.9749 177.748C86.6019 177.085 85.8561 176.795 85.2967 177.105C84.758 177.416 84.613 178.224 84.9859 178.887Z",
    fill: "#D66C55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8816 179.74L88.0322 179.678C88.0322 179.678 87.9079 180.859 88.6537 180.651C88.8195 180.61 88.8816 179.74 88.8816 179.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.92 145.262C137.813 145.262 146.644 136.432 146.644 125.538C146.644 114.645 137.813 105.814 126.92 105.814C116.027 105.814 107.196 114.645 107.196 125.538C107.196 136.432 116.027 145.262 126.92 145.262Z",
    stroke: "#081E54",
    strokeWidth: 0.517959,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.605 149.68V169.031",
    stroke: "#081E54",
    strokeWidth: 0.517959,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.705 133.436L161.002 138.594",
    stroke: "#081E54",
    strokeWidth: 0.517959,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.068,
    cy: 159.083,
    r: 20.5112,
    fill: "#00B479"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.411,
    y: 149.971,
    width: 3.31494,
    height: 18.2321,
    rx: 1.65747,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.185,
    y: 157.426,
    width: 3.31494,
    height: 18.2321,
    rx: 1.65747,
    transform: "rotate(90 207.185 157.426)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2975_77233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 287.013,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgImg);
export default __webpack_public_path__ + "static/media/BgImg.1a35904fee27b4e8547b9c80ba42a4fa.svg";
export { ForwardRef as ReactComponent };